import type { SVGProps } from "react";

export function IconBlackAmazonSquare(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Square outline */}
      <rect
        x="2.25"
        y="2.25"
        width="19.5"
        height="19.5"
        stroke="#23232C"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Amazon arrow */}
      <path
        d="M6.75 12.5503V11.75H5.25V12.5503C5.25 15.6981 7.80186 18.25 10.9497 18.25C12.4614 18.25 13.9112 17.6495 14.9801 16.5806L17.25 14.3107V17.25H18.75V11.75H13.25V13.25H16.1893L13.9194 15.5199C13.1318 16.3075 12.0636 16.75 10.9497 16.75C8.63029 16.75 6.75 14.8697 6.75 12.5503Z"
        fill="#23232C"
      />
    </svg>
  );
}
